import React from 'react';
import {useTranslation} from "react-i18next";
import {Col, Container, Nav, NavItem, NavLink, Row} from "reactstrap";

const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className="footer">
            <div className="container">
                <Row className="row-grid align-items-center mb-5">
                    <Col>
                        <h3 className="text-primary font-weight-light mb-2">
                            {t('ForensCalc')}
                        </h3>
                        <h4 className="mb-0 font-weight-light">
                            {t('ForensDesc')}
                        </h4>
                    </Col>
                    <Col>
                        <a href="https://github.com/Gorbacheb" target="_blank" rel="nofollow" className="btn btn-icon-only btn-github rounded-circle" data-toggle="tooltip" data-original-title="Star on Github">
                            <span className="btn-inner--icon"><i className="fab fa-github"></i></span>
                        </a>
                    </Col>
                </Row>
                <hr />
                <Row className="align-items-center justify-content-xl-between">
                    <Col className="md-6">
                        <div className="copyright text-sm text-muted text-lg-start">
                            &copy; {new Date().getFullYear()}, made by
                            <a href="https://github.com/Gorbacheb" className="font-weight-bold" target="_blank" rel="noopener noreferrer"> Vladimir Nedugov</a>
                        </div>
                    </Col>
                    <Col className="md-6">
                        <Nav className="nav-footer justify-content-center justify-content-xl-end">
                            <NavItem>
                                 <NavLink
                                    href="https://www.creative-tim.com?ref=adr-admin-footer"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                 >
                                     Scopus
                                 </NavLink>
                            </NavItem>
                            <NavItem>
                                 <NavLink
                                    href="https://www.creative-tim.com?ref=adr-admin-footer"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                 >
                                     РИНЦ
                                 </NavLink>
                            </NavItem>
                        </Nav>
                    </Col>
                </Row>
                </div>
        </footer>
    );
};

export default Footer;
